@let item = segment();

<ion-item-group class="segment-detail-group">
  <ion-item-divider sticky>
    <ion-icon
      slot="start"
      aria-hidden="true"
      src="../assets/material-symbols/route_24dp.svg"
    ></ion-icon>
    <div>
      <p class="subtitle">
        @if (totalSegments() > 1) {
          Tramo {{ index() + 1 }} de {{ totalSegments() }}
        } @else {
          Tramo único
        }
      </p>
    </div>
  </ion-item-divider>

  <div class="detail-group">
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col
          size="12"
          size-lg="6"
        >
          <div class="detail-data-block">
            <ion-icon
              aria-hidden="true"
              src="../assets/material-symbols/summarize_24dp.svg"
            ></ion-icon>
            <div>
              <p class="subtitle">Descripción de la mercancía</p>
              <p>
                <strong>{{ item.goodsDescription || 'Sin especificar' }}</strong>
              </p>
              @if (canModifyGoodsData() && isShipper() && !isCreator() && !isPastDocument()) {
                <ion-button
                  shape="round"
                  fill="outline"
                  size="small"
                  (click)="editGoods.emit()"
                  [disabled]="actionsDisabled()"
                >
                  <ion-icon
                    slot="start"
                    src="../assets/material-symbols/edit_24dp.svg"
                  ></ion-icon>
                  Editar descripción
                </ion-button>
              }
            </div>
          </div>
        </ion-col>
        <ion-col
          size="12"
          size-lg="6"
        >
          <div class="detail-data-block">
            <ion-icon
              aria-hidden="true"
              src="../assets/material-symbols/weight_24dp.svg"
            ></ion-icon>
            <div>
              <p class="subtitle">Peso neto</p>
              <p>
                @if (item.netWeight) {
                  <strong>{{ item.netWeight }} kg</strong>
                } @else {
                  <strong><ion-text color="danger">Sin asignar</ion-text></strong>
                }
              </p>
              @if (canModifyGoodsData() && isShipper() && !isCreator() && !isPastDocument()) {
                <ion-button
                  shape="round"
                  fill="outline"
                  size="small"
                  (click)="editWeight.emit()"
                  [disabled]="actionsDisabled()"
                >
                  <ion-icon
                    slot="start"
                    src="../assets/material-symbols/edit_24dp.svg"
                  ></ion-icon>
                  Editar peso
                </ion-button>
              }
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row class="ion-no-padding ion-margin-top">
        <ion-col
          size="12"
          size-lg="6"
          class="ion-no-padding"
        >
          <div class="detail-data-block">
            <ion-icon
              aria-hidden="true"
              src="../assets/material-symbols/line_start_circle_24dp.svg"
            ></ion-icon>
            <div>
              <p class="subtitle">Origen tramo {{ index() + 1 }}</p>
              <div>
                @if (item.origin.date) {
                  <p><strong>Fecha prevista:</strong> {{ item.origin.date | dfnsFormat: 'ccc Pp' }}</p>
                }
                @if (canModifyDates() && isCarrier() && !isCreator() && !isPastDocument()) {
                  <ion-button
                    shape="round"
                    fill="outline"
                    size="small"
                    (click)="editDate.emit('origin')"
                    [disabled]="actionsDisabled()"
                  >
                    <ion-icon
                      slot="start"
                      src="../assets/material-symbols/edit_24dp.svg"
                    ></ion-icon>
                    Editar fecha
                  </ion-button>
                }
                <p class="fs-sm">
                  <strong>{{ item.origin.companyName }}</strong
                  >. {{ item.origin.street }}, ({{ item.origin.postalCode }}) {{ item.origin.city }},
                  {{ 'states.' + item.origin.countryCode + item.origin.stateCode | translate }},
                  {{ 'countries.' + item.origin.countryCode | translate }}
                </p>
                @if (canModifyLocations() && isShipper() && !isCreator() && !isPastDocument()) {
                  <ion-button
                    shape="round"
                    fill="outline"
                    size="small"
                    (click)="editAddress.emit('origin')"
                    [disabled]="actionsDisabled()"
                  >
                    <ion-icon
                      slot="start"
                      src="../assets/material-symbols/edit_24dp.svg"
                    ></ion-icon>
                    Editar dirección
                  </ion-button>
                }
              </div>
            </div>
          </div>
        </ion-col>
        <ion-col
          size="12"
          size-lg="6"
          class="ion-no-padding"
        >
          <div class="detail-data-block">
            <ion-icon
              aria-hidden="true"
              src="../assets/material-symbols/line_end_square_24dp.svg"
            ></ion-icon>
            <div>
              <p class="subtitle">Destino tramo {{ index() + 1 }}</p>

              <div>
                @if (item.destination.date) {
                  <p><strong>Fecha prevista:</strong> {{ item.destination.date | dfnsFormat: 'ccc Pp' }}</p>
                }
                @if (canModifyDates() && isCarrier() && !isCreator() && !isPastDocument()) {
                  <ion-button
                    shape="round"
                    fill="outline"
                    size="small"
                    (click)="editDate.emit('destination')"
                    [disabled]="actionsDisabled()"
                  >
                    <ion-icon
                      slot="start"
                      src="../assets/material-symbols/edit_24dp.svg"
                    ></ion-icon>
                    Editar fecha
                  </ion-button>
                }
                <p class="fs-sm">
                  <strong>{{ item.destination.companyName }}</strong
                  >. {{ item.destination.street }}, ({{ item.destination.postalCode }}) {{ item.destination.city }},
                  {{ 'countries.' + item.destination.countryCode | translate }}
                </p>
                @if (canModifyLocations() && isShipper() && !isCreator() && !isPastDocument()) {
                  <ion-button
                    shape="round"
                    fill="outline"
                    size="small"
                    (click)="editAddress.emit('destination')"
                    [disabled]="actionsDisabled()"
                  >
                    <ion-icon
                      slot="start"
                      src="../assets/material-symbols/edit_24dp.svg"
                    ></ion-icon>
                    Editar dirección
                  </ion-button>
                }
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-item-group>
